import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { IonRouterOutlet } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { LogEvent } from 'src/app/interfaces/log';
import { GeneralService } from 'src/app/services/general/general.service';
import { LogService } from 'src/app/services/log/log.service';
import { RouterService } from './../../services/router/router.service';
import { UserService } from './../../services/user/user.service';

type Tab = 'menu' | 'main' | 'friends' | 'profile';

@Component({
  selector: 'app-global-navigation',
  templateUrl: './global-navigation-bar.component.html',
  styleUrls: ['./global-navigation-bar.component.scss'],
})
export class GlobalNavigationBarComponent implements OnInit, OnDestroy {

  tabBefore: Tab = 'main';
  tabCurrent: Tab = 'main';
  isApp = this.generalService.isApp;
  user = this.userService.user;
  private routerSubscription: Subscription | undefined;
  private userSubscription: Subscription | undefined;

  constructor(
    private logService: LogService, 
    private generalService: GeneralService, 
    private userService: UserService,
    private routerService: RouterService,
    protected routerOutlet: IonRouterOutlet) {
  }

  ngOnInit() {
    this.initializeTab();
    this.userSubscription = this.userService.getUserSubject().subscribe((user) => this.user = user);
    this.subscribeRouter();
    this.blockSwipeGesture();
  }

  ngOnDestroy(): void {
    if (this.userSubscription !== undefined) {
      this.userSubscription.unsubscribe();
    }
    if (this.routerSubscription !== undefined) {
      this.routerSubscription.unsubscribe();
    }
  }

  onClickTab(tab: Tab): void {
    this.setCurrentTab(tab);
    switch (tab) {
      case 'menu':
        this.logService.eventLogging(LogEvent.GNB_MENU);
        return;
      case 'main':
        this.logService.eventLogging(LogEvent.GNB_HOME);
        return;
      case 'friends':
        this.logService.eventLogging(LogEvent.GNB_FRIENDS);
        return;
      case 'profile':
        this.logService.eventLogging(LogEvent.GNB_PROFILE)
    }
  }

  private blockSwipeGesture(): void {
    this.routerOutlet.swipeGesture = false;
  }

  private initializeTab(): void {
    let path: Tab | string = location.pathname;
    path = path.replace('/gnb/', '') as Tab;
    this.tabBefore = this.tabCurrent = path as Tab;
  }

  private setCurrentTab(tab: Tab): void {
    this.tabBefore = this.tabCurrent;
    this.tabCurrent = tab;
    this.blockSwipeGesture();
  }

  private subscribeRouter(): void {
    this.routerSubscription = this.routerService.getRouterSubject()
      .subscribe((navigationData: NavigationEnd) => {
        const { url } = navigationData;
        if (url.includes('gnb/main')) {
          this.setCurrentTab('main');
        }
        if (url.includes('gnb/menu')) {
          this.setCurrentTab('menu');
        }
        if (url.includes('gnb/friends')) {
          this.setCurrentTab('friends');
        }
        if (url.includes('gnb/profile')) {
          this.setCurrentTab('profile');
        }
      });
  }
}
